import { useNavigate } from 'react-router';

import amazed from '@/assets/characters/inky/svgs/amazed.svg';
import Button from '@/V2/components/ui/button/button';

const SoloStart = () => {
  const navigate = useNavigate();
  return (
    <div className='h-screen'>
      <div className='flex justify-center items-center relative h-full'>
        <div className='flex justify-center '>
          <img src={amazed} width={'65%'} height={'65%'} />
        </div>
        <div className='pt-5 mt-6 bg-[#FAF8F7] border-[#DCDAD9] border-t w-3/5 h-[150px] absolute top-1/2 '>
          <div className='flex flex-row justify-center items-center text-center'>
            <span role='image' aria-label='sparkles'>
              ✨
            </span>
            <span className='font-faireLumaSans text-[32px] mx-1'>
              Ready to get stared?
            </span>
            <span role='image' aria-label='sparkles'>
              ✨
            </span>
          </div>
          <div className='w-full pt-8 flex justify-center'>
            <Button
              variant='primary'
              size='large'
              className='text-sm'
              onClick={() => navigate('/brand-wiki-setup')}
            >
              Let's Go!
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SoloStart;
